import { HttpClient } from "@angular/common/http";
import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { finalize, take } from "rxjs/operators";
import { verifyPhoneNumber } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  state = "login";
  loginState = "phone";
  registerState = "phone";
  registerAuthState = false;
  openConsentAgreement = false;
  ticariIletiAgreement = false;
  email = "";
  phone = "";
  password = "";
  registerPassword = "";
  registerPasswordConfirm = "";
  registerVerifyCode = "";
  verificationEnabled = false;

  showForgotPassword = false;

  // Survey data structure
  surveyQuestions = [
    {
      id: "gender",
      question: "Cinsiyetiniz?",
      type: "single",
      required: true,
      options: [
        { value: "Kadın", label: "Kadın" },
        { value: "Erkek", label: "Erkek" },
        { value: "Belirtmek istemiyorum", label: "Belirtmek istemiyorum" },
      ],
    },
    {
      id: "city",
      question: "Hangi şehirde yaşıyorsunuz?",
      type: "single",
      required: true,
      options: [
        { value: "İstanbul", label: "İstanbul" },
        { value: "Ankara", label: "Ankara" },
        { value: "İzmir", label: "İzmir" },
        { value: "Bursa", label: "Bursa" },
        { value: "Antalya", label: "Antalya" },
        { value: "Adana", label: "Adana" },
        { value: "Konya", label: "Konya" },
        { value: "Şanlıurfa", label: "Şanlıurfa" },
        { value: "Gaziantep", label: "Gaziantep" },
        { value: "other", label: "Diğer" },
      ],
    },
    {
      id: "age_group",
      question: "Yaşınız hangi aralıktadır?",
      type: "single",
      required: true,
      options: [
        { value: "18 – 24 yaş arasında", label: "18 – 24 yaş arasında" },
        { value: "25 – 34 yaş arasında", label: "25 – 34 yaş arasında" },
        { value: "35 – 44 yaş arasında", label: "35 – 44 yaş arasında" },
        { value: "45 – 54 yaş arasında", label: "45 – 54 yaş arasında" },
        { value: "55 – 65 yaş arasında", label: "55 – 65 yaş arasında" },
        { value: "65'den büyük", label: "65'den büyük" },
        { value: "other", label: "Diğer" },
      ],
    },
    {
      id: "work_status",
      question: "Çalışma durumunuzu hangisi en iyi ifade eder?",
      type: "single",
      required: true,
      options: [
        { value: "Öğrenciyim", label: "Öğrenciyim" },
        {
          value: "Kamuda ücretli çalışıyorum",
          label: "Kamuda ücretli çalışıyorum",
        },
        {
          value: "Özel sektörde ücretli çalışıyorum",
          label: "Özel sektörde ücretli çalışıyorum",
        },
        {
          value: "Kendi hesabıma çalışıyorum",
          label: "Kendi hesabıma çalışıyorum",
        },
        {
          value: "Çalışmıyorum ama iş arıyorum",
          label: "Çalışmıyorum ama iş arıyorum",
        },
        {
          value: "Çalışmıyorum, iş de aramıyorum",
          label: "Çalışmıyorum, iş de aramıyorum",
        },
        { value: "Emekliyim", label: "Emekliyim" },
      ],
    },
    {
      id: "shopping_category",
      question: "Hangi kategorilerde alışveriş yapıyorsunuz?",
      type: "multiple",
      maxSelections: 5,
      required: true,
      options: [
        {
          value: "Hazır Giyim (Kadın, erkek, ayakkabı vb.)",
          label: "Hazır Giyim (Kadın, erkek, ayakkabı vb.)",
        },
        {
          value: "Kişisel Bakım (parfüm, makyaj, şampuan vb.)",
          label: "Kişisel Bakım (parfüm, makyaj, şampuan vb.)",
        },
        {
          value: "Mobilya & Ev Dekorasyonu",
          label: "Mobilya & Ev Dekorasyonu",
        },
        {
          value: "Cafe & Restaurant",
          label: "Cafe & Restaurant",
        },
        {
          value: "Kitap & Kırtasiye",
          label: "Kitap & Kırtasiye",
        },
        {
          value: "Gıda (Market alışverişi, içecek vb.)",
          label: "Gıda (Market alışverişi, içecek vb.)",
        },
        {
          value: "Eğlence (tiyatro, sinema, konser vb.)",
          label: "Eğlence (tiyatro, sinema, konser vb.)",
        },
        {
          value: "Spor (spor giyim, ekipman, bisiklet vb.)",
          label: "Spor (spor giyim, ekipman, bisiklet vb.)",
        },
        {
          value: "Elektronik & Teknoloji (telefon, bilgisayar vb.)",
          label: "Elektronik & Teknoloji (telefon, bilgisayar vb.)",
        },
        { value: "other", label: "Diğer" },
      ],
    },
    {
      id: "free_time_activity",
      question: "Boş zamanlarınızda neler yapmayı seversiniz?",
      type: "multiple",
      maxSelections: 3,
      required: true,
      options: [
        {
          value: "Spor yapmak",
          label: "Spor yapmak",
        },
        {
          value: "Film/Dizi izlemek",
          label: "Film/Dizi izlemek",
        },
        {
          value: "Kitap okumak",
          label: "Kitap okumak",
        },
        {
          value: "Müzik dinlemek",
          label: "Müzik dinlemek",
        },
        {
          value: "Seyahat etmek",
          label: "Seyahat etmek",
        },
        {
          value: "İnternette gezinmek (Instagram, youtube vb.)",
          label: "İnternette gezinmek (Instagram, youtube vb.)",
        },
        { value: "Alışveriş yapmak", label: "Alışveriş yapmak" },
        {
          value: "Oyun oynamak (mobil, konsol, masa vb.)",
          label: "Oyun oynamak (mobil, konsol, masa vb.)",
        },
        {
          value: "Sanat/Kültür etkinlikleri",
          label: "Sanat/Kültür etkinlikleri",
        },
        { value: "other", label: "Diğer" },
      ],
    },
  ];

  surveyAnswers: { [key: string]: any } = {};
  surveyOtherInputs: { [key: string]: string } = {};

  verificationInterval;
  verificationSmsSecond = 0;
  verificationSending = false;
  verifySentDate = new Date();
  phoneSmsSent = false;

  showPasswordValidation = false;
  passwordValidations = [
    {
      type: "length",
      minLength: 6,
      maxLength: 12,
      message: "Şifreniz 6-12 karakter arasında olmalı",
    },
    {
      type: "regex",
      regex: /\d/,
      message: "Şifreniz en az 1 sayı içermelidir",
    },
  ];

  constructor(
    private router: Router,
    private user: UserService,
    private http: HttpClient,
    private metaService: MetaService
  ) {}

  ngOnInit(): void {
    this.metaService.set({
      title:
        "Giriş Yap - Anket çözüp para kazanmak için giriş yapın - Bilgesin",
      description:
        "Para kazandıran siteler içerisinde en güvenilir olanına kayıt olun. Formu doldurarak hediye kazanma fırsatını kaçırmayın.",
    });
  }

  @HostListener("document:keypress", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === "Enter") {
      if (this.state === "login") {
        this.login();
      } else if (this.state === "register") {
        this.register();
      }
    }
  }

  changeState(value: string) {
    if (value === "register" && this.loginState === "email") {
      this.router.navigate(["/is-ortagimiz-olmak-ister-misiniz"]);
      return;
    }
    this.state = value;
  }

  onPasswordChange(password: string) {
    this.registerPassword = password;
  }

  async login() {
    if (!this.password) {
      return alert("Lütfen tüm alanları doldurunuz");
    }
    if (this.loginState === "email" && !this.email) {
      return alert("Lütfen tüm alanları doldurunuz");
    }
    if (
      this.loginState === "phone" &&
      !verifyPhoneNumber(this.phone.toString())
    ) {
      return;
    }

    const resultCode = await this.user.login({
      email: this.email,
      password: this.password,
      phone: this.phone,
      isLoginPage: true,
      loginState: this.loginState,
    });
    if (resultCode === "NO_USER") {
      this.state = "register";
    }
  }

  // Survey methods
  onSurveyAnswerChange(questionId: string, value: any) {
    this.surveyAnswers[questionId] = value;

    // Clear other input if not "other" option
    if (Array.isArray(value)) {
      // For multiple selection questions
      if (!value.includes("other")) {
        delete this.surveyOtherInputs[questionId];
      }
    } else {
      // For single selection questions
      if (value !== "other") {
        delete this.surveyOtherInputs[questionId];
      }
    }
  }

  onOtherInputChange(questionId: string, value: string) {
    this.surveyOtherInputs[questionId] = value;
  }

  onMultipleSelectionChange(
    questionId: string,
    optionValue: string,
    isChecked: boolean
  ) {
    const question = this.surveyQuestions.find((q) => q.id === questionId);
    if (!question || question.type !== "multiple") return;

    let currentAnswers = this.surveyAnswers[questionId] || [];

    if (isChecked) {
      if (!currentAnswers.includes(optionValue)) {
        if (currentAnswers.length >= question.maxSelections) {
          currentAnswers.shift();
        }
        currentAnswers.push(optionValue);
      }
    } else {
      // Remove the option
      currentAnswers = currentAnswers.filter(
        (answer) => answer !== optionValue
      );
    }

    this.surveyAnswers[questionId] = currentAnswers;

    // Clear other input if "other" is not selected
    if (!currentAnswers.includes("other")) {
      delete this.surveyOtherInputs[questionId];
    }
  }

  isSurveyValid(): boolean {
    for (const question of this.surveyQuestions) {
      if (question.required) {
        const answer = this.surveyAnswers[question.id];

        // Check if question is answered
        if (!answer) {
          return false;
        }

        // Handle multiple selection questions
        if (question.type === "multiple") {
          if (!Array.isArray(answer) || answer.length === 0) {
            return false;
          }

          // If "other" is selected, check if other input is provided
          if (
            answer.includes("other") &&
            !this.surveyOtherInputs[question.id]?.trim()
          ) {
            return false;
          }
        } else {
          // Handle single selection questions
          // If "other" is selected, check if other input is provided
          if (
            answer === "other" &&
            !this.surveyOtherInputs[question.id]?.trim()
          ) {
            return false;
          }
        }
      }
    }
    return true;
  }

  register() {
    // Validate survey first
    if (!this.isSurveyValid()) {
      alert("Lütfen tüm anket sorularını cevaplayınız!");
      return false;
    }

    if (this.registerState != "phone") {
      if (!this.email) {
        alert("Lutfen 'e-posta' giriniz");
        return false;
      }
      if (this.email.indexOf("@") < -1) {
        alert("Lutfen gecerli bir 'e-posta' giriniz");
        return false;
      }
    } else {
      if (!verifyPhoneNumber(this.phone.toString())) {
        return false;
      }
    }

    if (!this.isPasswordValid()) {
      alert(
        "Şifreniz 6-12 karakter arasında olmalı ve en az 1 sayı içermelidir!"
      );
      return false;
    }

    if (this.registerPassword !== this.registerPasswordConfirm) {
      alert("Şifreler eşleşmiyor!");
      return false;
    }

    if (!this.verificationEnabled) {
      this.verificationEnabled = true;
      this.sendVerifyCodeToPhone();
      return false;
    }

    // Prepare survey data
    const surveyData = {};
    for (const question of this.surveyQuestions) {
      const answer = this.surveyAnswers[question.id];

      if (question.type === "multiple" && Array.isArray(answer)) {
        // Handle multiple selection questions
        if (answer.includes("other")) {
          // Replace "other" with the actual other input
          const otherIndex = answer.indexOf("other");
          const modifiedAnswer = [...answer];
          modifiedAnswer[otherIndex] = this.surveyOtherInputs[question.id];
          surveyData[question.id] = modifiedAnswer;
        } else {
          surveyData[question.id] = answer;
        }
      } else {
        // Handle single selection questions
        if (answer === "other") {
          surveyData[question.id] = this.surveyOtherInputs[question.id];
        } else {
          surveyData[question.id] = answer;
        }
      }
    }

    this.user
      .register({
        email: this.email,
        phone: this.phone,
        registerState: this.registerState,
        openConsentAgreement: this.openConsentAgreement,
        ticariIletiAgreement: this.ticariIletiAgreement,
        password: this.registerPassword,
        surveyData: Object.keys(surveyData)
          .filter((key) => surveyData[key])
          .map((key) => {
            return {
              id: key,
              title: this.surveyQuestions.find((q) => q.id === key)?.question,
              answer: surveyData[key],
            };
          }),
        verifyCode: this.registerVerifyCode,
        isRegisterPage: true,
      })
      .then((res: any) => {
        this.verificationEnabled = false;
        if (res === "login") {
          this.state = "login";
          this.loginState = this.registerState.toString();
          this.password = this.registerPassword.toString();
          this.login();
        }
      })
      .catch((err: any) => {
        this.verificationEnabled = false;
      });
  }

  hideResetPassword(result) {
    this.showForgotPassword = false;

    if (!result || !result.resetStatus) {
      return;
    }

    this.password = result.password;
    this.phone = result.phone;
    this.login();
  }

  sendVerifyCodeToPhone() {
    this.verificationInterval = setInterval(() => {
      const now = new Date();
      this.verificationSmsSecond =
        60 -
        parseInt(
          ((now.getTime() - this.verifySentDate.getTime()) / 1000).toString()
        );
    }, 1000);

    this.verificationSending = true;
    this.http
      .post("/send-verify-code-to-phone", {
        phone: this.phone,
        isRegisterPage: true,
      })
      .pipe(
        take(1),
        finalize(() => {
          setTimeout(() => (this.verificationSending = false), 1000);
        })
      )
      .subscribe((res: any) => {
        this.phoneSmsSent = !!(res.alreadySent || res.sent);
        if (this.phoneSmsSent) {
          this.verifySentDate = new Date();
        }
        if (!res.alreadySent && !res.sent) {
          alert(res.message);
        }
      });
  }

  get resendCodeText() {
    if (this.verificationSmsSecond >= 0) {
      return `${this.verificationSmsSecond}sn. - Şifreyi yeniden gönder`;
    }
    return "Şifreyi yeniden gönder";
  }

  isPasswordValid(): boolean {
    for (const validation of this.passwordValidations) {
      if (!this.isValidationValid(validation)) {
        return false;
      }
    }
    return true;
  }

  isValidationValid(validation: any): boolean {
    if (validation.type === "length") {
      return (
        this.registerPassword.length >= validation.minLength &&
        this.registerPassword.length <= validation.maxLength
      );
    }
    if (validation.type === "regex") {
      return validation.regex.test(this.registerPassword);
    }
    return true;
  }
}
